import { NgModule } from "@angular/core";
import { RouterModule } from "@angular/router";
import { MatButtonModule } from "@angular/material/button";
import { MatCardModule } from "@angular/material/card";
import { MatCheckboxModule } from "@angular/material/checkbox";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatIconModule } from "@angular/material/icon";
import { MatInputModule } from "@angular/material/input";
import { MatPaginatorModule } from "@angular/material/paginator";
import { MatRadioModule } from "@angular/material/radio";
import { MatSelectModule } from "@angular/material/select";
import { MatTableModule } from "@angular/material/table";
import { NgxLoadingModule } from "ngx-loading";
import { TranslateModule } from "@ngx-translate/core";

import { FuseSharedModule } from "@fuse/shared.module";
import { ConsultantComponent } from "./consultant.component";
import { GooglePlaceModule } from "@yuvarajv/ngx-google-places-autocomplete";
import { NgxMaskDirective, NgxMaskPipe, provideNgxMask } from "ngx-mask";
const routes = [
    {
        path: "consultants",
        component: ConsultantComponent,
    },
];

@NgModule({
    declarations: [ConsultantComponent],
    imports: [
        RouterModule.forChild(routes),
        GooglePlaceModule,
        TranslateModule,
        NgxLoadingModule.forRoot({}),
        FuseSharedModule,
        MatButtonModule,
        MatCardModule,
        MatFormFieldModule,
        MatInputModule,
        MatTableModule,
        MatPaginatorModule,
        MatIconModule,
        MatRadioModule,
        MatCheckboxModule,
        MatSelectModule,
        NgxMaskDirective,
        NgxMaskPipe
    ],
    exports: [ConsultantComponent],
})
export class ConsultantModule {}
